
import { motion } from 'framer-motion';

export default function WhatsAppButton() {
  return (
    <motion.a
      href="https://wa.me/5491162450002"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-6 right-6 z-50 cursor-pointer wa-float"
      initial={{ scale: 0, rotate: -180 }}
      animate={{ scale: 1, rotate: 0 }}
      transition={{
        type: 'spring',
        stiffness: 260,
        damping: 20,
        delay: 1,
      }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
    >
      <style>{`
        @keyframes wa-ping-1 {
          0% {
            transform: scale(1);
            opacity: 0.45;
          }
          100% {
            transform: scale(2.2);
            opacity: 0;
          }
        }
        @keyframes wa-ping-2 {
          0% {
            transform: scale(1);
            opacity: 0.35;
          }
          100% {
            transform: scale(2);
            opacity: 0;
          }
        }
        @keyframes wa-float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-8px);
          }
        }
        .wa-float {
          animation: wa-float 2.8s ease-in-out infinite;
        }
        .wa-ring-1 {
          animation: wa-ping-1 2.4s cubic-bezier(0, 0, 0.2, 1) infinite;
        }
        .wa-ring-2 {
          animation: wa-ping-2 2.4s cubic-bezier(0, 0, 0.2, 1) infinite;
          animation-delay: 0.8s;
        }
      `}</style>

      {/* Ondas suaves */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="absolute w-16 h-16 rounded-full border-2 border-[#25D366]/40 wa-ring-1" />
        <div className="absolute w-16 h-16 rounded-full border-2 border-[#25D366]/30 wa-ring-2" />
      </div>

      {/* Botón principal */}
      <div className="relative w-16 h-16 bg-[#25D366] rounded-full shadow-2xl flex items-center justify-center">
        <i className="ri-whatsapp-fill text-white text-3xl" />
      </div>
    </motion.a>
  );
}
